(function () {
    'use strict';

    var SECTIONS = {
        SEND_CODE: 0,
        VERIFY_CODE: 1
    };

    Directives.TwoFactorAuthDirective = function TwoFactorAuthDirective() {

        // @ngInject
        function TwoFactorAuthDirectiveControllerFunc($scope, $injector, UsersManager, UserService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'TwoFactorAuthDirectiveController';

            this.UsersManager = UsersManager;
            this.UserService = UserService;

            this.section = SECTIONS.SEND_CODE;
            this.user = this.UsersManager.getCurrUser();

            // set phone number hint
            this.phoneLast4 = this.user.securityPhoneNumberLastFourDigits();

            $scope.$watch('twoFactorAuthVm.error', function (newVal) {
                if (newVal) {
                    this.codeSubmitted = false;
                }
            }.bind(this));
        }

        var TwoFactorAuthDirectiveController = Class(Controllers.BaseController, {
            constructor: TwoFactorAuthDirectiveControllerFunc,

            sendVerificationCodeSms: function sendVerificationCodeSms() {
                this.selectedMethod = 'sms';
                this.verifyPhoneNumber();
            },

            sendVerificationCodeCall: function sendVerificationCodeCall() {
                this.selectedMethod = 'call';
                this.verifyPhoneNumber();
            },

            reset: function reset() {
                this.codeSubmitted = false;
                this.tokenSendInProgress = false;
                this.selectedMethod = null;
                this.error = null;
                this.section = SECTIONS.SEND_CODE;
            },

            verifyPhoneNumber: function verifyPhoneNumber() {
                this.error = null;
                this.tokenSendInProgress = true;
                this.UsersManager.sendPhoneVerification(this.selectedMethod)
                    .then(function () {
                        this.section = SECTIONS.VERIFY_CODE;
                    }.bind(this))
                    .catch(function (res) {
                        if (res.status === 429) {
                            this.error = 'Oops! An error has occurred. Please retry later or contact our support at concierge@honeybook.com';
                        } else if (res && res.error && res.error.message) {
                            this.error = res.error.message;
                        } else if (res && res.data && res.data.error_message) {
                            this.error = res.data.error_message;
                        } else {
                            this.error = 'Oops! An error has occurred during verification process. If the problem persists, please contact our support at concierge@honeybook.com';
                        }
                    }.bind(this))
                    .finally(function () {
                        this.tokenSendInProgress = false;
                    }.bind(this));
            },

            submit: function submit() {
                this.error = null;
                this.codeSubmitted = true;
                this.onCodeSubmit({code: this.userCode, justClose: false});
            },

            close: function close() {
                this.onCodeSubmit({code: null, justClose: true});
            },

            allowCalls: function allowCalls() {
                return this.UserService.has2FAQualificationPeriodPassed(this.user);
            }
        });

        return {
            scope: {
                onCodeSubmit: '&onCodeSubmit',
                error: '='
            },
            controller: TwoFactorAuthDirectiveController,
            templateUrl: 'angular/app/modules/common/ui_components/phone_verification/two_factor_auth_directive_template.html',
            controllerAs: 'twoFactorAuthVm',
            bindToController: true
        };
    };
}());

